import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestCount = 0;
  private readonly _isLoading = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this._isLoading.asObservable();
  suppressed = false;

  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      Promise.resolve().then(() => {
        if (this.requestCount > 0) {
          this._isLoading.next(true);
        }
      });
    }
  }

  hide(): void {
    this.requestCount = Math.max(this.requestCount - 1, 0);

    if (this.requestCount === 0) {
      setTimeout(() => {
        if (this.requestCount === 0) {
          this._isLoading.next(false);
        }
      }, 600);
    }
  }
}
